"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultClock = void 0;
Object.defineProperty(exports, "ethereumSaga", {
  enumerable: true,
  get: function () {
    return _saga.ethereumSaga;
  }
});
exports.getTxReceiptStatusFn = exports.getSignerContractFn = exports.getFormatterFn = exports.getEncodedCallFn = exports.getContractFn = exports.getAbiNameFn = exports.getABIFn = void 0;
exports.initializeEthereumStore = initializeEthereumStore;
exports.selectUserAddressFn = exports.selectProviderFn = exports.selectChainIdFn = void 0;
var _saga = require("./store/ethereum/saga");
// Helpers
let getEncodedCallFn = exports.getEncodedCallFn = void 0;
let getContractFn = exports.getContractFn = void 0;
let getABIFn = exports.getABIFn = void 0;
let getAbiNameFn = exports.getAbiNameFn = void 0;
let getFormatterFn = exports.getFormatterFn = void 0;
let getSignerContractFn = exports.getSignerContractFn = void 0;
let getTxReceiptStatusFn = exports.getTxReceiptStatusFn = void 0;
let defaultClock = exports.defaultClock = void 0;

// User
let selectUserAddressFn = exports.selectUserAddressFn = void 0;
let selectChainIdFn = exports.selectChainIdFn = void 0;
let selectProviderFn = exports.selectProviderFn = void 0;
function initializeEthereumStore(options) {
  const {
    getEncodedCall,
    getContract,
    getABI,
    getAbiName,
    getFormatter,
    getSignerContract,
    getTxReceiptStatus,
    selectUserAddress,
    selectChainId,
    selectProvider,
    clockCount
  } = options;
  exports.getEncodedCallFn = getEncodedCallFn = getEncodedCall;
  exports.getContractFn = getContractFn = getContract;
  exports.getABIFn = getABIFn = getABI;
  exports.getAbiNameFn = getAbiNameFn = getAbiName;
  exports.getFormatterFn = getFormatterFn = getFormatter;
  exports.getSignerContractFn = getSignerContractFn = getSignerContract;
  exports.getTxReceiptStatusFn = getTxReceiptStatusFn = getTxReceiptStatus;
  exports.selectUserAddressFn = selectUserAddressFn = selectUserAddress;
  exports.selectChainIdFn = selectChainIdFn = selectChainId;
  exports.selectProviderFn = selectProviderFn = selectProvider;
  exports.defaultClock = defaultClock = clockCount || 10;
}